import React, { useEffect, useState } from 'react';
import Layout from '../components/Layout';
import { ContasService } from '../services';
import api from '../services/api';

const initForm = { nome: '', email: '', senha: '', conta_ids: [] };

export default function SubUsuarios() {
  const [subUsuarios, setSubUsuarios] = useState([]);
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState(initForm);
  const [editando, setEditando] = useState(null); // id do sub-user sendo editado
  const [gerenciandoContas, setGerenciandoContas] = useState(null); // sub-user sendo vinculado
  const [contasSelecionadas, setContasSelecionadas] = useState([]);
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  const carregar = () => {
    setLoading(true);
    Promise.all([
      api.get('/sub-usuarios').then(r => r.data),
      ContasService.listar(),
    ])
      .then(([subs, contas]) => { setSubUsuarios(subs); setContas(contas); })
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => { carregar(); }, []);

  const salvarForm = async (e) => {
    e.preventDefault();
    setErro('');
    setSalvando(true);
    try {
      if (editando) {
        await api.put(`/sub-usuarios/${editando}`, { nome: form.nome, senha: form.senha || undefined });
      } else {
        await api.post('/sub-usuarios', form);
      }
      setForm(initForm);
      setEditando(null);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  const excluir = async (id) => {
    if (!window.confirm('Remover este usuário?')) return;
    try {
      await api.delete(`/sub-usuarios/${id}`);
      carregar();
    } catch {}
  };

  const abrirGerenciarContas = (sub) => {
    setGerenciandoContas(sub);
    setContasSelecionadas([...(sub.conta_ids || [])]);
  };

  const salvarContas = async () => {
    setSalvando(true);
    try {
      await api.put(`/sub-usuarios/${gerenciandoContas.id}/contas`, { conta_ids: contasSelecionadas });
      setGerenciandoContas(null);
      carregar();
    } catch (err) {
      setErro(err.response?.data?.erro || 'Erro ao salvar');
    } finally {
      setSalvando(false);
    }
  };

  const toggleConta = (id) => {
    setContasSelecionadas(prev =>
      prev.includes(id) ? prev.filter(c => c !== id) : [...prev, id]
    );
  };

  const iniciarEdicao = (sub) => {
    setEditando(sub.id);
    setForm({ nome: sub.nome, email: sub.email, senha: '', conta_ids: sub.conta_ids || [] });
    setErro('');
  };

  const cancelar = () => { setEditando(null); setForm(initForm); setErro(''); };

  const inputStyle = { padding: '8px 12px', border: '1.5px solid var(--gray-200)', borderRadius: 8, fontSize: 13, width: '100%', boxSizing: 'border-box' };

  return (
    <Layout title="Usuários">
      <div className="grid-2" style={{ alignItems: 'start' }}>

        {/* Formulário */}
        <div className="card">
          <div className="card-header">
            <span className="card-title">{editando ? '✏️ Editar Usuário' : '➕ Novo Usuário de Visualização'}</span>
          </div>
          <div className="card-body">
            <form onSubmit={salvarForm} style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--gray-600)', display: 'block', marginBottom: 4 }}>Nome</label>
                <input style={inputStyle} value={form.nome} onChange={e => setForm(f => ({ ...f, nome: e.target.value }))} required placeholder="Nome do usuário" />
              </div>
              {!editando && (
                <div>
                  <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--gray-600)', display: 'block', marginBottom: 4 }}>E-mail</label>
                  <input style={inputStyle} type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} required placeholder="email@exemplo.com" />
                </div>
              )}
              <div>
                <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--gray-600)', display: 'block', marginBottom: 4 }}>
                  {editando ? 'Nova senha (deixe em branco para não alterar)' : 'Senha'}
                </label>
                <input style={inputStyle} type="password" value={form.senha} onChange={e => setForm(f => ({ ...f, senha: e.target.value }))} required={!editando} placeholder={editando ? 'Deixe em branco para manter' : 'Senha de acesso'} />
              </div>

              {!editando && (
                <div>
                  <label style={{ fontSize: 12, fontWeight: 500, color: 'var(--gray-600)', display: 'block', marginBottom: 6 }}>Contas vinculadas</label>
                  {contas.length === 0 ? (
                    <p style={{ fontSize: 12, color: 'var(--gray-500)' }}>Nenhuma conta cadastrada.</p>
                  ) : contas.map(c => (
                    <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6, cursor: 'pointer', fontSize: 13 }}>
                      <input
                        type="checkbox"
                        checked={form.conta_ids.includes(c.id)}
                        onChange={() => setForm(f => ({
                          ...f,
                          conta_ids: f.conta_ids.includes(c.id)
                            ? f.conta_ids.filter(x => x !== c.id)
                            : [...f.conta_ids, c.id]
                        }))}
                      />
                      <span className="color-dot" style={{ background: c.cor }} />
                      {c.icone} {c.nome}
                    </label>
                  ))}
                </div>
              )}

              {erro && <p style={{ fontSize: 12, color: 'var(--danger)', margin: 0 }}>{erro}</p>}

              <div style={{ display: 'flex', gap: 8 }}>
                <button type="submit" className="btn btn-primary" disabled={salvando} style={{ flex: 1 }}>
                  {salvando ? 'Salvando...' : editando ? 'Salvar alterações' : 'Criar usuário'}
                </button>
                {editando && (
                  <button type="button" className="btn btn-secondary" onClick={cancelar}>Cancelar</button>
                )}
              </div>
            </form>
          </div>
        </div>

        {/* Lista */}
        <div className="card">
          <div className="card-header"><span className="card-title">👥 Usuários de Visualização</span></div>
          {loading ? (
            <div className="loading-wrap"><div className="spinner" /></div>
          ) : subUsuarios.length === 0 ? (
            <div className="empty-state"><p>Nenhum usuário de visualização cadastrado.</p></div>
          ) : (
            <div style={{ padding: '8px 0' }}>
              {subUsuarios.map(sub => (
                <div key={sub.id} style={{ padding: '12px 20px', borderBottom: '1px solid var(--gray-100)' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    <div>
                      <div style={{ fontWeight: 600, fontSize: 13 }}>{sub.nome}</div>
                      <div style={{ fontSize: 12, color: 'var(--gray-500)', marginTop: 2 }}>{sub.email}</div>
                      <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                        {sub.conta_ids && sub.conta_ids.length > 0 ? (
                          sub.conta_ids.map(cid => {
                            const c = contas.find(x => x.id === cid);
                            return c ? (
                              <span key={cid} style={{
                                display: 'inline-flex', alignItems: 'center', gap: 4,
                                background: 'var(--gray-100)', borderRadius: 20,
                                padding: '2px 8px', fontSize: 11
                              }}>
                                <span className="color-dot" style={{ background: c.cor, width: 7, height: 7 }} />
                                {c.nome}
                              </span>
                            ) : null;
                          })
                        ) : (
                          <span style={{ fontSize: 11, color: 'var(--warning)', fontStyle: 'italic' }}>Sem conta vinculada</span>
                        )}
                      </div>
                    </div>
                    <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                      <button className="btn btn-sm btn-secondary" onClick={() => abrirGerenciarContas(sub)} title="Gerenciar contas">🏦</button>
                      <button className="btn btn-sm btn-secondary" onClick={() => iniciarEdicao(sub)} title="Editar">✏️</button>
                      <button className="btn btn-sm btn-danger" onClick={() => excluir(sub.id)} title="Remover">🗑️</button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Modal gerenciar contas */}
      {gerenciandoContas && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,.5)', zIndex: 200, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <div className="card" style={{ width: 380, maxWidth: '90vw', margin: 0 }}>
            <div className="card-header">
              <span className="card-title">🏦 Contas de {gerenciandoContas.nome}</span>
              <button className="btn btn-ghost btn-sm" onClick={() => setGerenciandoContas(null)}>✕</button>
            </div>
            <div className="card-body">
              <p style={{ fontSize: 12, color: 'var(--gray-500)', marginBottom: 12 }}>
                Selecione quais contas este usuário pode visualizar:
              </p>
              {contas.map(c => (
                <label key={c.id} style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, cursor: 'pointer', fontSize: 13 }}>
                  <input type="checkbox" checked={contasSelecionadas.includes(c.id)} onChange={() => toggleConta(c.id)} />
                  <span className="color-dot" style={{ background: c.cor }} />
                  {c.icone} {c.nome}
                  <span style={{ fontSize: 11, color: 'var(--gray-400)', marginLeft: 'auto', textTransform: 'capitalize' }}>{c.tipo}</span>
                </label>
              ))}
              <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
                <button className="btn btn-primary" onClick={salvarContas} disabled={salvando} style={{ flex: 1 }}>
                  {salvando ? 'Salvando...' : 'Salvar'}
                </button>
                <button className="btn btn-secondary" onClick={() => setGerenciandoContas(null)}>Cancelar</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
}
